module.exports = __webpack_public_path__ + "img/abstract2.14cd34b.svg";